const SlimEpaHeader = () => {
  return (
    <header className="header" aria-label="Site header">
      <nav
        className="navbar-expand-xl container-fluid container-t4-xl"
        aria-label="Header navigation"
      >
        <div className="header__container">
          <a href="https://www.epa.ie/" className="navbar-logo">
            <img
              src="https://www.epa.ie/media/epa-2020/site-assets/images/logo/epawebnew.svg"
              alt="Environmental Protection Agency Logo"
            />
          </a>
        </div>
      </nav>
    </header>
  );
};

export { SlimEpaHeader };
